import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Copy, Link2, Loader2, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { Switch } from '../../components/ui/switch';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/brand-kit/share`;
const linkFor = (t) => `${window.location.origin}/brand/${t}`;

export const SharePanel = () => {
  const [share, setShare] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(API).then((r) => setShare(r.data)).catch(() => setShare({ enabled: false })); }, []);

  const call = async (fn, msg) => {
    setBusy(true);
    try { const r = await fn(); setShare(r.data); if (msg) toast.success(msg); } catch (e) { toast.error('Could not update the link'); } finally { setBusy(false); }
  };
  const toggle = (v) => call(() => axios.post(API, { enabled: v }), v ? 'Public link is on' : 'Public link turned off');
  const regen = () => {
    if (window.confirm('Create a new link? The current link will stop working.')) call(() => axios.post(`${API}/regenerate`), 'New link created');
  };
  const copy = async () => {
    await navigator.clipboard.writeText(linkFor(share.token));
    toast.success('Link copied');
  };
  if (!share) return null;

  return (
    <div className="bk-share" data-testid="brandkit-share-panel">
      <Link2 size={15} />
      <span>Public link</span>
      <Switch checked={share.enabled} onCheckedChange={toggle} disabled={busy} data-testid="brandkit-share-toggle" />
      {busy && <Loader2 size={14} className="animate-spin" />}
      {share.enabled && share.token && (
        <>
          <input readOnly value={linkFor(share.token)} onFocus={(e) => e.target.select()} data-testid="brandkit-share-url" />
          <button type="button" className="bk-btn" onClick={copy} data-testid="brandkit-share-copy"><Copy size={14} /> Copy</button>
          <button type="button" className="bk-icon-btn" onClick={regen} title="Replace with a new link" data-testid="brandkit-share-regenerate">
            <RefreshCw size={14} />
          </button>
        </>
      )}
    </div>
  );
};
